import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import { resetPassword } from "../../services/authService";

const ResetPassword = () => {
  
  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const token = queryParams.get("token");

  const [formData, setFormData] = useState({
    newpassword: "",
    confirmpassword: "",
  });
  const [errors, setErrors] = useState({});

  // HANDLE INPUT
  const handleChange = (e) => {

    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });

    // REMOVE ERROR WHILE TYPING
    setErrors({
      ...errors,
      [e.target.name]: "",
    });
  };

  // HANDLE SUBMIT
  const handleSubmit = async (e) => {
    e.preventDefault();
    let newErrors = {};

    // NEW PASSWORD VALIDATION
    if (!formData.newpassword) {
      newErrors.newpassword = "New Password is required";
    } else if (formData.newpassword.length < 6) {
      newErrors.newpassword =
        "Password must be at least 6 characters";
    }

    // CONFIRM PASSWORD VALIDATION
    if (!formData.confirmpassword) {
      newErrors.confirmpassword =
        "Confirm Password is required";
    } else if (
      formData.newpassword !== formData.confirmpassword
    ) {
      newErrors.confirmpassword =
        "Passwords do not match";
    }
    setErrors(newErrors);

    // STOP IF ERRORS
    if (Object.keys(newErrors).length > 0) return;
    try {
      const data = await resetPassword({
        resettoken: token,
        pwd: formData.newpassword,
      });
      console.log(data);
      toast.success(
        data.message || "Password reset successfully"
      );

      // REDIRECT TO LOGIN PAGE
      navigate("/login");
    } catch (error) {
      console.error(error);
      toast.error(
        error.response?.data?.message ||
        "Password reset failed"
      );
    }
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        background:
          "linear-gradient(135deg, #eef2ff, #dbeafe)",
        padding: "20px",
      }}
    >
      {/* CARD */}
      <div
        style={{
          width: "100%",
          maxWidth: "400px",
          background: "#fff",
          borderRadius: "18px",
          padding: "35px 30px",
          boxShadow: "0 8px 25px rgba(0,0,0,0.12)",
          position: "relative",
        }}
      >
        {/* BACK BUTTON */}
        <button
          onClick={() => navigate("/login")}
          style={{
            position: "absolute",
            top: "18px",
            right: "20px",
            background: "transparent",
            border: "none",
            color: "#4f46e5",
            fontSize: "14px",
            cursor: "pointer",
            fontWeight: "600",
          }}
        >
          ← Back
        </button>

        {/* TITLE */}
        <h2
          style={{
            textAlign: "center",
            marginBottom: "25px",
            color: "#4338ca",
            fontSize: "28px",
            fontWeight: "700",
          }}
        >
          Reset Password
        </h2>

        {/* FORM */}
        <form onSubmit={handleSubmit}>

          {/* NEW PASSWORD */}
          <div style={{ marginBottom: "18px" }}>
            <input
              type="password"
              name="newpassword"
              placeholder="Enter New Password"
              value={formData.newpassword}
              onChange={handleChange}
              style={{
                width: "100%",
                padding: "14px",
                borderRadius: "10px",
                border: errors.newpassword
                  ? "1px solid red"
                  : "1px solid #d1d5db",
                fontSize: "15px",
                outline: "none",
                boxSizing: "border-box",
              }}
            />

            {errors.newpassword && (
              <p
                style={{
                  color: "red",
                  fontSize: "13px",
                  marginTop: "6px",
                }}
              >
                {errors.newpassword}
              </p>
            )}
          </div>

          {/* CONFIRM PASSWORD */}
          <div style={{ marginBottom: "20px" }}>
            <input
              type="password"
              name="confirmpassword"
              placeholder="Confirm Password"
              value={formData.confirmpassword}
              onChange={handleChange}
              style={{
                width: "100%",
                padding: "14px",
                borderRadius: "10px",
                border: errors.confirmpassword
                  ? "1px solid red"
                  : "1px solid #d1d5db",
                fontSize: "15px",
                outline: "none",
                boxSizing: "border-box",
              }}
            />

            {errors.confirmpassword && (
              <p
                style={{
                  color: "red",
                  fontSize: "13px",
                  marginTop: "6px",
                }}
              >
                {errors.confirmpassword}
              </p>
            )}
          </div>

          {/* BUTTON */}
          <button
            type="submit"
            style={{
              width: "100%",
              padding: "14px",
              background:
                "linear-gradient(90deg, #4f46e5, #7c3aed)",
              color: "white",
              border: "none",
              borderRadius: "10px",
              cursor: "pointer",
              fontSize: "16px",
              fontWeight: "600",
              transition: "0.3s",
            }}
          >
            Reset Password
          </button>

        </form>
      </div>
    </div>
  );
};

export default ResetPassword;